import { useQuery } from '@tanstack/react-query';

import { lcmApi } from '~/shared/services/api';

export const GET_WIDGET_RESULTS_QUERY_KEY = 'homeV2/useGetWidgetResults';

export type WidgetResultsResponse = {
  managerCompleted: boolean;
  selfCompleted: boolean;
  success: boolean;
};

async function getWidgetResults(): Promise<WidgetResultsResponse> {
  const { data } = await lcmApi.get<WidgetResultsResponse>('/widgets/results');
  return data;
}

export function useGetWidgetResults() {
  return useQuery({
    queryKey: [GET_WIDGET_RESULTS_QUERY_KEY],
    queryFn: getWidgetResults,
  });
}
